import(/* webpackMode: "eager" */ "/tmp/build_6d544f5b/src/app/encomendas/layout.tsx");
